if not App.angularApp?
    return

###
Apply to any text input. Auto-formats whole numbers with commas
Strips non digits.

Example of expected results
input => result
200 => 200
20.14 => 2,014
2000 => 2,000
20000 => 20,000
asdf1 => 1
###
App.angularApp.directive 'mfFormatWholeNumber', ['$parse', ($parse) ->
    return {
        restrict: 'A'
        require: 'ngModel'
        link: ($scope, elem, attrs, ngModel) =>

            ngModel.$parsers.unshift (viewValue) =>
                if viewValue isnt ''
                    # store previous value
                    previous = $scope.previous

                    # If it hasn't changed
                    if viewValue isnt previous
                        # remove decimals and non digits
                        viewValue = String(viewValue).replace(/[\.\D]/g, '')

                        # add thousands separator
                        viewValue = String(viewValue).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')

                        # update value
                        $scope.previous = viewValue

                        # Set viewValue and render html
                        ngModel.$setViewValue($scope.previous)
                        ngModel.$render()
                        return $scope.previous
                    else
                        return true
                else
                    return true
    }
]
